// extracted by mini-css-extract-plugin
module.exports = {"grid":"VideoList_grid__UnHqH","reverse":"VideoList_reverse__Xxre6","img":"VideoList_img__MLvfo","content":"VideoList_content__elxUr"};